import { render, staticRenderFns } from "./SimpleProductListSlider.vue?vue&type=template&id=299d60a2"
import script from "./SimpleProductListSlider.vue?vue&type=script&lang=js"
export * from "./SimpleProductListSlider.vue?vue&type=script&lang=js"
import style0 from "./SimpleProductListSlider.vue?vue&type=style&index=0&id=299d60a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports